import pica from 'pica';

/**
 *
 * @param {*} file
 *
 * @returns {Promise<File>} - A promise that resolves with the resized image file.
 */
export default async (file, maxHeight = 80) => new Promise(async (resolve) => {
  const image = new Image();
  image.src = URL.createObjectURL(file);
  image.onload = async () => {
    const canvas = document.createElement('canvas');
    const aspectRatio = image.width / image.height;
    canvas.width = maxHeight * aspectRatio;
    canvas.height = maxHeight;

    await pica().resize(image, canvas);
    canvas.toBlob((blob) => {
      resolve(new File([blob], `${file.name}`, { type: file.type }));
    }, file.type);
  };
});
